import { ValidationRepository } from "../../domain/repositories/ValidationRepository";
import { ValidationResponse } from "../../domain/entities/ValidationEntity";
import { InvoiceEntity } from "../../domain/entities/InvoiceEntity";
import { validateInvoiceDocument } from "../api/validationApi";

export class ValidationRepositoryImpl implements ValidationRepository {
  async validateInvoice(
    invoiceData: any,
    invoiceDocument: InvoiceEntity,
    validationType: string = "full_validation"
  ): Promise<ValidationResponse> {
    // Use feature-specific API
    const response = await validateInvoiceDocument(
      invoiceData,
      invoiceDocument,
      validationType
    );
    return response;
  }
}
